import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import { HomePresenter } from '@/app/ui/presenters/HomePresenter'
import { User, Export, Import } from '@/domain/entities/User'
import { AuthModule } from '@/app/store/modules/auth'
import router from '@/router'
import {
  UserApiRequest,
  DeleteUserRequest,
  UpdateUserRequest,
  PostImportRequest,
  UpdateUserDnetRequest,
} from '@/data/payload/api/UserRequest'
import Vue from 'vue'
import axios from 'axios'
import { removeAuthCredential } from '@/utils/cookies'

export interface UserState {
  userDataDNET: User
  userDataSFD: User
  exportData: any
  importData: any
  isLoading: boolean
  fields: any
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'userlist' })
class Users extends VuexModule implements UserState {
  public isLoadingExport = true
  public token = ''
  public isLoading = true
  public fields = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'title', sortable: true },
    { key: 'attachment', sortable: false },
    { key: 'deletable', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'createdAt', sortable: false },
    { key: 'actions', sortable: false },
  ]
  public userDataDNET = new User(true, '')
  public userDataSFD = new User(true, '')
  public exportData = new Export(true, '')
  public importData = new Import(true, '', '', '')
  public paginationParamsExport = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'id',
      type: 'asc',
    },
    search: '',
    filter: {
      team: '',
      position: '',
      dealercode: '',
      dealergroup: '',
      statusDNET: '',
      statusRegistration: '',
      typeSales: '',
      dealerarea: '',
      dealername: '',
      dealerCity: '',
      dealerBranch: '',
      active: '',
      salescode: '',
      type: 'dnet',
    },
  }
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'id',
      type: 'asc',
    },
    search: '',
    filter: {
      team: '',
      position: '',
      dealercode: '',
      dealergroup: '',
      statusDNET: '',
      statusRegistration: '',
      typeSales: '',
      dealerarea: '',
      dealername: '',
      dealerCity: '',
      dealerBranch: '',
      active: '',
      type: 'dnet',
    },
  }

  @Action
  public async getUserDataDNET() {
    // console.log("this params "+this.paginationParam.filter.active);
    this.setLoading(true)
    const presenter = await container.resolve(HomePresenter)
    presenter
      .loadUser(this.paginationParam)
      .then((res: User) => {
        this.setUserDataDNET(res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
          this.setUserDataDNET(error)
        }
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getUserDataSFID() {
    // console.log("this params "+this.paginationParam.filter.active);
    this.setLoading(true)
    const presenter = await container.resolve(HomePresenter)
    presenter
      .loadUser(this.paginationParam)
      .then((res: User) => {
        this.setUserDataSFD(res)
        //  console.log('resssssSSSSSSSS', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
          this.setUserDataDNET(error)
        }
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getExportData() {
    this.setLoadingExport(true)
    const presenter = await container.resolve(HomePresenter)
    presenter
      .loadExport(this.paginationParamsExport)
      .then((res: Export) => {
        this.setExportData(res)
        //  console.log('export dataaa', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
      })
      .finally(() => {
        this.setLoadingExport(false)
      })
  }

  @Action
  public async postImport(params: { fileName: string; fileByte: string }) {
    this.setLoading(true)
    const presenter = await container.resolve(HomePresenter)
    presenter
      .postImport(new PostImportRequest(params.fileName, params.fileByte))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Import',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getUserDataSFID()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'Import',
          message: 'Failed',
          type: 'error',
          duration: 5000,
        })
      })
  }

  @Action
  public async postUser(params: {
    salesmanCode: string
    salesmanName: string
    email: string
    phone: string
    password: string
    passwordConfirmation: string
    jobPositionId: number
    dealerGroup: string
    isActive: string
    Notes: string
    Register: string
    from: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(HomePresenter)
    presenter
      .postUser(
        new UserApiRequest(
          params.salesmanCode,
          params.salesmanName,
          params.email,
          params.phone,
          params.password,
          params.passwordConfirmation,
          params.jobPositionId,
          params.dealerGroup,
          params.isActive,
          params.Notes,
          params.Register,
          params.from
        )
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'User',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getUserDataSFID()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'User',
          message: 'Failed',
          type: 'error',
          duration: 5000,
        })
      })
  }

  @Action
  public async updateUser(params: {
    id: number
    salesmanName: string
    email: string
    password: string
    phone: string
    notes: string
    dealerGroup: string
    position: string
    isActive: boolean
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(HomePresenter)
    presenter
      .updateUser(
        new UpdateUserRequest(
          params.salesmanName,
          params.email,
          params.password,
          params.phone,
          params.notes,
          params.dealerGroup,
          params.position,
          params.isActive
        ),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'User',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getUserDataSFID()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'User',
          message: 'Failed',
          type: 'error',
          duration: 5000,
        })
      })
  }

  @Action
  public async updateUserDnet(params: {
    salesCode: string
    password: string
    email: string
    phoneNumber: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(HomePresenter)
    presenter
      .updateUserDnet(
        new UpdateUserDnetRequest(
          params.salesCode,
          params.password,
          params.email,
          params.phoneNumber
        )
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'User',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getUserDataDNET()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'User',
          message: 'Failed',
          type: 'error',
          duration: 5000,
        })
      })
  }

  @Action
  public async deleteUser(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(HomePresenter)
    presenter
      .deleteUser(new DeleteUserRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'User',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getUserDataSFID()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'User',
          message: 'Failed to delete',
          type: 'error',
          duration: 5000,
        })
        //  console.log(error)
      })
  }

  @Mutation
  private setUserDataDNET(user: User) {
    this.userDataDNET = user
  }
  @Mutation
  private setUserDataSFD(user: User) {
    this.userDataSFD = user
  }
  @Mutation
  private setExportData(exp: Export) {
    this.exportData = exp
  }
  @Mutation
  private setImportData(imp: Import) {
    this.importData = imp
  }
  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  @Mutation
  private setLoadingExport(isLoadingExport: boolean) {
    this.isLoadingExport = isLoadingExport
  }
  @Mutation
  private setToken(token: string) {
    this.token = token
  }
}

export const UserModule = getModule(Users)
